import { Routes } from '@angular/router';
import { authGuard } from './services/auth.guard';
import { wipHandoffGuard } from './services/wip-handoff.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('./login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'mfa',
    loadComponent: () => import('./mfa/mfa.component').then(m => m.MfaComponent)
  },
  {
    path: ':tenantId/handoff/:token/wip',
    canActivate: [wipHandoffGuard],
    loadComponent: () =>
      import('./wip-handoff/wip-handoff.component').then(m => m.WipHandoffComponent),
  },
  {
    path: ':tenantId/wip',
    canActivate: [authGuard],
    loadComponent: () => import('./wip/dashboard/wip-dashboard.component').then(m => m.WipDashboardComponent)
  },
  {
    path: ':tenantId/wip/completed',
    canActivate: [authGuard],
    loadComponent: () => import('./wip/completed/completed-jobs.component').then(m => m.CompletedJobsComponent)
  },
  {
    path: ':tenantId/admin',
    canActivate: [authGuard],
    loadComponent: () => import('./admin/admin.component').then(m => m.AdminComponent)
  },
  { path: '**', redirectTo: '/login' }
];
